import keymirror from 'keymirror';
import { AsyncRequest } from 'angieslist-app-platform';

export default keymirror({
  UPDATE_CATEGORY_LIST: null,
  FILTER_CATEGORY_LIST: null,
  UPDATE_OPT_INS: null,
  ...AsyncRequest.createActionKeys('GET_SERVICE_PROVIDER_CATEGORIES'),
  ...AsyncRequest.createActionKeys('GET_CATEGORIES_WITH_METRICS'),
  ...AsyncRequest.createActionKeys('ADD_CATEGORIES_TO_SERVICE_PROVIDER'),
  ...AsyncRequest.createActionKeys('REMOVE_CATEGORIES_FROM_SERVICE_PROVIDER'),
  ...AsyncRequest.createActionKeys('SET_CATEGORY_OPT_IN'),
});



// WEBPACK FOOTER //
// ./src/app/common/categories/categoriesActionKeys.js